import * as React from "react";
import { Switch, useLocation, RouteProps } from "react-router-dom";
import { AnimatePresence } from "framer-motion";

export const AnimatedRoutes: React.FC<RouteProps> = ({
  children,
  exitBeforeEnter = true,
  initial = false,
}: RouteProps) => {
  const location = useLocation();
  return (
    <AnimatePresence exitBeforeEnter={exitBeforeEnter} initial={initial}>
      <Switch location={location} key={location.pathname}>
        {children}
      </Switch>
    </AnimatePresence>
  );
};
